import { z } from 'my-zod'
import { customerWaiversSystemView } from './customer-waivers-system-view'

export const customerWaiversBriefSystemView = customerWaiversSystemView.pick({
  id: true,
  productLineForRental: true,
  driverFirstName: true,
  driverLastName: true,
  driverEmail: true,
  additionalParticipantFullName1: true,
  additionalParticipantFullName2: true,
  additionalParticipantFullName3: true,
  additionalParticipantFullName4: true,
  additionalParticipantFullName5: true,
  createdDate: true
})

export type customerWaiversBriefSystemView = z.infer<typeof customerWaiversBriefSystemView>
